import { render, staticRenderFns } from "./view-claim.vue?vue&type=template&id=54f3f472&scoped=true"
import script from "./view-claim.vue?vue&type=script&lang=js"
export * from "./view-claim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3f472",
  null
  
)

export default component.exports